import moment from "moment-timezone";
import Image from "next/image";
import Link from "next/link";

export default function AuthorInfo({ name, image, updatedDate, username }) {
  return (
    <div className="flex items-center gap-2 text-[11px] text-gray-500 border-b border-gray-200 pb-3 mb-4 py-2 mt-8">
      <div className="text-black text-[11px]">
        <span>Updated: </span>
        <time dateTime={updatedDate}>
          {moment(updatedDate).tz("Asia/Kolkata").format("MMM D, YYYY h:mm A")}
        </time>
      </div>

      <span className="text-gray-400">·</span>

      <span>by</span>

      <Link href={`/author/${username}`} className="flex items-center gap-1.5">
        <div className="relative w-[32px] h-[32px] rounded-full overflow-hidden">
          <Image
            src={image || "/placeholder.svg"}
            alt={name}
            fill
            className="object-cover"
          />
        </div>

        <span className="text-gray-700 font-medium">{name}</span>
      </Link>
    </div>
  );
}
